"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(data) {
  // First clean up from last session
  // clear the masquerading properties, or they will persist between sessions
  // even if the user stops masquerading
  _mixpanelBrowser.default.unregister('Masqueraded By');

  _mixpanelBrowser.default.unregister('Client Impersonation'); // check if the current user is different from the previous user,
  // if so make sure a new session starts


  if (_mixpanelBrowser.default.get_distinct_id() !== data.user_id) {
    // either a brand new user or a different user in the same browser
    // either way, force a new session
    _mixpanelBrowser.default.unregister('Last Action');
  }

  _mixpanelBrowser.default.people.set_once('First Access Date', new Date().toISOString());

  _mixpanelBrowser.default.register({
    'Organization Name': data.organization,
    'Organization ID': data.organization_id,
    'User Group Name': data.user_group,
    'User Group ID': data.user_group_id
  }); // current product related properties


  (0, _utils.updateCurrentProduct)(data.current_product);

  if (data.anon) {
    _mixpanelBrowser.default.people.set({
      'User Type': _constants.USER_TYPES.anonymous
    });

    _mixpanelBrowser.default.register({
      'User Type': _constants.USER_TYPES.anonymous
    });
  } else {
    _mixpanelBrowser.default.register({
      Department: data.department || undefined,
      'User Type': _constants.USER_TYPES.registered,
      'Client Impersonation': data.mask ? data.mask.client_impersonation : undefined,
      'Masquerading As': data.mask ? data.mask.email : undefined
    });
  }

  if (data.user_id) {
    _mixpanelBrowser.default.identify("".concat(data.user_id));
  }
};

exports.default = _default;